module.exports = __webpack_public_path__ + "components/rewards/vista-tours/static/logo-9a1781d5ba4fb487aebb220d3d1373e6.jpg";